export default class extends Controller {
  static targets = ["formPlaceholder", "fileFormTemplate", "linkFormTemplate", "bulkAddTemplate"]

  connect() {
    App.Helpers.listenToCustomEvent(document, "assets--file-select", this.openFormAndTriggerFileSelect.bind(this))
    App.Helpers.listenToCustomEvent(document, "assets--create-new-link", this.openNewLinkForm.bind(this))
    App.Helpers.listenToCustomEvent(document, "assets--open-add-existing-form", this.openAddExistingForm.bind(this))
    App.Helpers.listenToCustomEvent(document, "assets--bulk-create-success", this.addNewRowsFrom.bind(this))
  }

  openFormAndTriggerFileSelect(event) {
    const { dataTransfer } = event.detail
    const file = dataTransfer.files[0];
    const formID = Math.random().toString(36).slice(2) // random string for the form to use as an identifier
    this.openFormWith(this.pendingUploadTemplateFor(file.name, formID))
    setTimeout((() => dispatchCustomEvent("asset--file-exchange", this.element, { dataTransfer, formID })).bind(this), 100)
  }

  openNewLinkForm(event) {
    this.openFormWith(this.linkFormTemplateTarget.innerHTML)
  }

  openAddExistingForm(event) {
    const { el: element, assetType, headerColor, title } = event.detail
    App.SlideOut.open({ element, contentHTML: this.bulkAddTemplateFor(assetType), headerColor, title })
    App.addHandlers(".vex-content");
  }

  openFormWith(content) {
    dispatchCustomEvent("assets--show-group", this.element, {})
    App.Helpers.appendAfter(content, this.formPlaceholderTarget)
  }

  pendingUploadTemplateFor(filename, key) {
    return this.fileFormTemplateTarget.innerHTML.replace(/UPLOAD_FILENAME|ASSET_NAME/g, filename).replace(/UPLOAD_ID/g, key)
  }

  bulkAddTemplateFor(assetType) {
    const singularizedType = this.singularizeAssetType(assetType)
    return this.bulkAddTemplateTarget.innerHTML.replace(/ASSET_TYPE/g, singularizedType)
  }

  addNewRowsFrom(event) {
    const { newRows } = event.detail;
    (newRows || []).forEach(row => this.openFormWith(row))
  }

  singularizeAssetType(assetType) {
    switch(assetType) {
      case "files":
        return "file";
      case "links":
        return "link";
      default:
        return assetType
    }
  }
};



// WEBPACK FOOTER //
// ./app/components/assets/assets/javascript/assets-list-controller.js